import Header from './Header'
import globalStyles from '../styles/global.module.css'
import styles from './Layout.module.css'

const Layout = ({ children }) => {
  return (
    <div className={styles.layoutContainer}>
      <div className={styles.headerWrapper}>
        <Header />
      </div>
      <main className={globalStyles.container}>
        {children}
      </main>
    </div>
  )
}

export default Layout 